/* eslint-disable @typescript-eslint/no-unused-vars */
import { useRef, useState } from 'react';
import { useAlert } from 'providers/AlertModalProvider';
import useCheckPermission from 'hooks/custom/useCheckPermission';
import ShowChallanDetail from 'views/payment/transaction-history/ShowChallanDetail';
import useShowModal from 'hooks/custom/useShowModal';
import { useModal } from 'providers/ConfirmationModalProvider';
import postData from 'services/postData';
import PageSwitch from 'components/custom/template/PageSwitch';
import Page from 'components/custom/template/Page';
import { hrmsPaths } from 'constants/pagePath';
import { useNavigate } from 'react-router-dom';
import apiEndpoints from 'constants/apiEndpoints';
import fetchData from 'services/fetchData';
import useManagePageLoading from 'hooks/custom/useManagePageLoading';
import flyAshPaymentColumns from './paymentPendingColumns';
import FlyAshProceedPaymentPending from '../FlyAshProceedPaymentPending';
import ChangeDriverForChallans from 'views/payment/quick-payment/ChangeDriverForChallans';
import GetFlyAshChallanModal from 'views/challan/flyash/GetFlyAshChallanModal';

const FlyAshPaymentPending = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [getChallanModal, setGetChallanModal] = useState(false);
  const [proceedData, setProceedData] = useState({});
  const [focusedRow, setFocusedRow] = useState(false);
  const { userAllow } = useCheckPermission(['Payer']);
  const challanDetail = useShowModal();
  const [loading, loadingText, handleLoading] = useManagePageLoading();
  const { showConfirmation } = useModal();
  const navigate = useNavigate();
  const refreshDataRef = useRef(null);
  const pushCustomDataRef = useRef(null);
  const [openChangeDriver, setOpenChangeDriver] = useState(false);
  const [vehicleDriverData, setVehicleDriverData] = useState(null);
  const handleChangeDriver = data => {
    setVehicleDriverData(data);
    setOpenChangeDriver(true);
  };
  const handleRefreshDataRegister = refreshData => {
    refreshDataRef.current = refreshData;
  };

  const handlePushCustomDataRegister = pushCustomData => {
    pushCustomDataRef.current = pushCustomData;
  };

  const { showAlert } = useAlert();

  const handleProceedPayment = async (id, handleSwitchPage) => {
    const response = await fetchData(apiEndpoints.challan.getChallanDetail(id));
    if (response.status) {
      const fetchedData = response.data;
      // const individualData = fetchedData.find(c => c.id === id);
      setProceedData(fetchedData);
      setTimeout(() => {
        handleSwitchPage();
      }, 200);
    } else {
      console.log('Failed to get data :', response.message);
    }
  };

  const handleCancelChallan = challan => {
    showConfirmation({
      onConfirm: async () => {
        handleLoading(true, 'Canceling the challan');
        const requestStatus = await postData(
          {
            challan_id: challan.challan_id,
            challan_no: challan.challan_no
          },
          apiEndpoints.challan.cancelChallan
        );
        if (requestStatus.status) {
          handleLoading(false);
          showAlert({
            variant: 'success',
            message: `The Challan ${challan.challan_no} has been successfully Canceled.`
          });
          refresh();
        } else {
          handleLoading(false);
          showAlert({
            variant: 'danger',
            message: `Failed to cancel the challan ${challan.challan_no}. Please try again.`
          });
        }
      },
      message: `Are you sure you want to cancel the challan ${challan.challan_no}?`,
      severity: 'danger',
      confirmBtn: 'Confirm'
    });
  };

  const updateFetchChallan = challan => {
    if (pushCustomDataRef.current) {
      const challanIndex = fetchedData.findIndex(c => c.id === challan.id);
      let challanData = fetchedData;
      if (challanIndex >= 0) {
        challanData.splice(challanIndex, 1);
      }
      pushCustomDataRef.current([challan, ...challanData]);
    }
  };

  const refresh = async () => {
    if (refreshDataRef.current) {
      refreshDataRef.current();
    }
  };

  const handleDriverPreview = data => {
    navigate(`${hrmsPaths.driver.update(data.driver_id)}?tab=${1}`);
  };
  return (
    <div>
      <PageSwitch
        switchPage={handleBack => (
          <FlyAshProceedPaymentPending
            refresh={refresh}
            proceedData={proceedData || {}}
            handleBack={handleBack}
          />
        )}
      >
        {handleSwitchPage => (
          <Page
            backdrop={{ loading: loading, message: loadingText }}
            showIllustration={true}
            highlightedRow={focusedRow}
            title={'Fly Ash Pending payments'}
            tableColumn={{
              column: flyAshPaymentColumns(
                id => handleProceedPayment(id, handleSwitchPage),
                userAllow,
                challanDetail.handleOpenModal,
                handleCancelChallan,
                // handleLoading,
                handleChangeDriver
              ),
              actions: false
            }}
            // urlEndPoint={'get_ironore_list?type=1'}
            exportName="Fly Ash Pending payments"
            addNew={() => setGetChallanModal(true)}
            addBtnText="Get Challan"
            onRegisterRefresh={handleRefreshDataRegister}
            onRegisterPushCustomData={handlePushCustomDataRegister}
            fetchCallback={setFetchedData}
            urlEndPoint={'challan_payment/get_payment_pending_flyash'}
            excelButtonProps={{ onlyTableFields: true }}
            // dummyData={dummyData}`
          >
            {getChallanModal ? (
              <GetFlyAshChallanModal
                showAlert={showAlert}
                updateFetchChallan={updateFetchChallan}
                setFocusedRow={setFocusedRow}
                show={getChallanModal}
                handleClose={() => setGetChallanModal(false)}
                handleRefresh={refresh}
              />
            ) : null}
            {challanDetail.isOpen && challanDetail.modalData && (
              <ShowChallanDetail
                show={challanDetail.isOpen}
                handleClose={challanDetail.handleCloseModal}
                challan_no={challanDetail.modalData?.challan_id}
                trans_for={'Fly Ash'}
              />
            )}

            {openChangeDriver ? (
              <ChangeDriverForChallans
                refreshData={refresh}
                show={openChangeDriver}
                handleClose={() => setOpenChangeDriver(false)}
                data={vehicleDriverData}
              />
            ) : null}
          </Page>
        )}
      </PageSwitch>
    </div>
  );
};

export default FlyAshPaymentPending;
